import { memo, useEffect, useState } from "react";
import ModalComponent from "@zenith/components/ui/ModalComponent/modal-component/modal-component";
import {
  SERVICE_MODAL_BODY,
  SERVICE_MODAL_TITLE,
} from "@zenith/data/constants";

export interface ShareServiceFailureComponentProps {
  hasError: boolean;
  onClose: () => void;
  retryFn?: () => Promise<void>;
}

const ShareServiceFailureComponent = memo(function ServiceFailureComponent({
hasError,
  onClose,
  retryFn
}: ShareServiceFailureComponentProps) {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(hasError);
  }, [hasError]);

const handleTryAgain = async () => {
  if (retryFn) {
    try {
      await retryFn();
      onClose();
    } catch (error) {
      console.error("Retry failed again:", error);
    }
  }
};

  return (
      <ModalComponent
        title={SERVICE_MODAL_TITLE}
        body={SERVICE_MODAL_BODY}
        showModal={showModal}
        onClickButton={handleTryAgain}
        onClickClose={onClose}
        buttonText="Try again"
      />
  );
});

export default ShareServiceFailureComponent;